import script from "./RightToWorkCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./RightToWorkCompleted.vue?vue&type=script&setup=true&lang=js"

import "./RightToWorkCompleted.vue?vue&type=style&index=0&id=6e44e406&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e44e406"]])

export default __exports__